"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipTextTypes = exports.tooltipTextDescription = exports.default = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var tooltipTextTypes = [_stencilReactDesc.PropTypes.element, _stencilReactDesc.PropTypes.string];
exports.tooltipTextTypes = tooltipTextTypes;
var tooltipTextDescription = 'Content to display in the tooltip.';
exports.tooltipTextDescription = tooltipTextDescription;
var tooltipPropTypes = {
  isInline: _stencilReactDesc.PropTypes.bool.description('Indicates that the tooltip is inline in a sentence.'),
  tooltipText: _stencilReactDesc.PropTypes.oneOfType(tooltipTextTypes).isRequired.description(tooltipTextDescription),
  tooltipPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TOOLTIP_POSITION)).description('Vertical position for the tooltip relative to the trigger.'),
  tooltipAlignment: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TooltipAlignment)).description('Horizontal alignment for the tooltip relative to the trigger.'),
  tooltipDataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM for the tooltip content."),
  children: _stencilReactDesc.PropTypes.func.isRequired.description('Render function which renders the trigger for the tooltip.').format("({\n  open: function,\n  close: function,\n  isOpen: boolean,\n  tooltipId: string\n}) => node")
};
var _default = tooltipPropTypes;
exports.default = _default;